import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnInit,
    Output,
    ViewChild,
    EventEmitter
} from '@angular/core';
import { ImageCroppedEvent } from '../image-cropper/interfaces';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ControlImageCropperComponent } from '../image-cropper/component/control-image-cropper/control-image-cropper.component';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'lib-webcam-snapshot',
    templateUrl: './webcam-snapshot.component.html',
    styleUrls: ['./webcam-snapshot.component.css'],
    imports: [ControlImageCropperComponent, MatIcon, TranslatePipe]
})
export class WebcamSnapshotComponent implements AfterViewInit {
    @Input() WIDTH = 640;
    @Input() HEIGHT = 480;
    @Input() imageCropper = true;
    activeImageCropper = false;
    isActiveCamera = false;

    @Input() maxCaptures = 1;

    @ViewChild('video')
    public video: ElementRef;

    @ViewChild('canvas')
    public canvas: ElementRef;

    @Output() capturesChange = new EventEmitter<any[]>();
    @Output() imageSelected = new EventEmitter<any>();

    captures: string[] = [];
    error: any;
    isCaptured = false;
    imageCurrent;
    imageChangedEvent;
    imageBase64;
    constructor(public translate:TranslateService) {
    }
    async ngAfterViewInit() {
        await this.setupDevices();
    }

    async setupDevices() {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: true
                });
                if (stream) {
                    this.video.nativeElement.srcObject = stream;
                    this.video.nativeElement.play();
                    this.error = null;
                    this.isActiveCamera = true;
                } else {
                    this.error = 'You have no output video device';
                }
            } catch (e) {
                this.error = e;
            }
        }
    }

    capture() {
        this.drawImageToCanvas(this.video.nativeElement);
        this.captures.push(this.canvas.nativeElement.toDataURL('image/png'));
        if (this.captures.length>1 && this.captures.length === this.maxCaptures) {
            this.captures = this.captures.slice(1);
        }
        this.imageCurrent = this.captures.length - 1;
        this.isCaptured = true;
        this.activeImageCropper = true;
        this.imageBase64 = this.captures[this.imageCurrent];
    }

    removeCurrent() {
        this.isCaptured = false;
        this.activeImageCropper = false;
        this.imageChangedEvent = null;
    }

    setPhoto(idx: number) {
        this.imageCurrent = idx;
        this.isCaptured = true;
        this.activeImageCropper = true;
        const image = new Image();
        image.src = this.captures[idx];
        this.imageBase64 = this.captures[this.imageCurrent];
        this.drawImageToCanvas(image);
    }

    drawImageToCanvas(image: any) {
        this.canvas.nativeElement
            .getContext('2d')
            .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);
    }

    validCapture() {
        const img = this.captures[this.imageCurrent];
        this.imageSelected.emit(img);
    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
        this.activeImageCropper = true;
    }

    imageCropped(event: ImageCroppedEvent) {
        console.log('--------', event);
        console.log(this.captures);
        // if (this.isActiveCamera) {
        //     this.isCaptured = true;
        // }
        this.isCaptured = true;
        if (this.captures.length > 0) {
            this.captures[this.imageCurrent] = event.base64;
        } else {
            this.captures = [];
            this.captures.push(event.base64);
            this.imageCurrent = 0;
        }
    }
}
